var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import normalize from "./normalize";
import { risItemToRcItem } from "./mapper";
import { tokenize } from "./tokenizer";
import { tokensToRisItems } from "./tokensToRisItems";
import { SimpleCtx as TokenizerCtx } from "./tokenizerCtx";
export const identifyMode = ({ text }) => {
    if (!text.length)
        throw new Error("I've no content to parse - text is empty!");
    text = normalize(text);
    const ctx = new TokenizerCtx({ text });
    tokenize({ ctx, errors: [] });
    return ctx.detectedMode;
};
const separateWarningsAndErrors = (errors) => {
    const warnings = errors
        .filter(e => e.severity === 'warning');
    const errors_ = errors
        .filter(e => e.severity === 'error');
    return { warnings, errors: errors_ };
};
const asRisItems = ({ text, mode }) => {
    const errors = [];
    if (!text.length)
        throw new Error("I've no content to parse - text is empty!");
    text = normalize(text);
    const ctx = new TokenizerCtx({ text, mode });
    const tokens = tokenize({ ctx, errors });
    const risItems = tokensToRisItems({ ctx, tokens, errors });
    return { normalizedText: text, risItems, errors };
};
const risResultsAsRcItems = ({ text, risItems, hash, errors, removeSquareBracketsFromAuthors, keywordDestination }) => __awaiter(void 0, void 0, void 0, function* () {
    let rcItems = [];
    errors = errors || [];
    for (const risItem of risItems) {
        const rcItem = yield risItemToRcItem(risItem, text, hash, errors, { removeSquareBracketsFromAuthors, keywordDestination });
        rcItems.push(rcItem);
    }
    rcItems = rcItems.filter(r => r);
    return { risItems, rcItems, errors };
});
export const asRcItems = ({ text, hash, mode, removeSquareBracketsFromAuthors, keywordDestination }) => __awaiter(void 0, void 0, void 0, function* () {
    const { normalizedText, risItems, errors } = asRisItems({ text, mode });
    const result = yield risResultsAsRcItems({
        text: normalizedText,
        risItems,
        hash,
        removeSquareBracketsFromAuthors,
        errors,
        keywordDestination,
    });
    return Object.assign(Object.assign({}, result), separateWarningsAndErrors(result.errors));
});
